export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Дауды ашу"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Болдырмау"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Жіберу"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Көмек үшін модератор қосылады. Себебін таңдап, дәлелдемелерді тіркеңіз."])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Модераторға жіберу"])}
}